import Chart from 'chart.js'

Chart.defaults.global.animation.duration = 2000

const getDataLarge = (data = []) => ({
    type: 'doughnut',
    data: {
        datasets: [{
            backgroundColor: ['#a5b342', 'rgba(216,216,216,0)'],
            hoverBackgroundColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
            borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
            hoverBorderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
            borderWidth: 1,
            data: data || []
        }]
    },
    options: {
        cutoutPercentage: 26,
        maintainAspectRatio: false,
        legend: {
            display: false
        }
    }
})

const getDataSmall = (data = []) => ({
    type: 'doughnut',
    data: {
        datasets: [{
            backgroundColor: ['#a5b342', '#dce7c9'],
            borderColor: 'rgba(255,255,255,0)',
            borderWidth: 1,
            data: data || []
        }]
    },
    options: {
        cutoutPercentage: 32,
        maintainAspectRatio: false,
        legend: {
            display: false
        }
    }
})

const isChartsVisible = (el) => {
    if (!el || !('getBoundingClientRect' in el))
        return false

    const bounds = el.getBoundingClientRect()
    return bounds.top <= window.innerHeight * 0.75
}

const renderCharts = (opts = {}) => {
    if (!opts.el || opts.el.classList.contains('charts--visible'))
        return

    const charts = [{
        canvas: opts.chartLargeCanvas,
        data: getDataLarge(opts.chartPercents)
    }, {
        canvas: opts.chartSmallCanvas,
        data: getDataSmall(opts.chartPercents)
    }]

    charts
        .forEach(obj => (new Chart(obj.canvas, obj.data)))

    opts.el.classList.add('charts--visible')
}

Array.from(document.querySelectorAll('.charts'))
    .map(el => ({
        el: el,
        chartPercents: (() => {
            const percents = []

            const largePercent = el.querySelector('.chart-large')
                ? Number(el.querySelector('.chart-large')
                    .getAttribute('data-percent'))
                : null

            const smallPercent = el.querySelector('.chart-small')
                ? Number(el.querySelector('.chart-small')
                    .getAttribute('data-percent'))
                : null

            if (largePercent)
                percents.push(largePercent)

            if (smallPercent)
                percents.push(smallPercent)

            return percents
        })(),
        chartLarge: el.querySelector('.chart-large'),
        chartLargeCanvas: el.querySelector('canvas#chart-large'),
        chartSmall: el.querySelector('.chart-small'),
        chartSmallCanvas: el.querySelector('canvas#chart-small')
    }))
    .filter((obj = {}) => {
        const isRender = obj.el
            && obj.chartPercents
            && obj.chartPercents.length === 2
            && obj.chartLarge
            && obj.chartLargeCanvas
            && obj.chartSmall
            && obj.chartSmallCanvas

        if (!isRender && obj.el)
            obj.el.remove()

        return isRender
    })
    .forEach((obj) => {
        if (isChartsVisible(obj.el))
            return renderCharts(obj)

        const chartsScrollListener = window
            .addEventListener('scroll', () => {
                if (!isChartsVisible(obj.el))
                    return

                window.removeEventListener('scroll', chartsScrollListener)
                renderCharts(obj)
            })
    })
